export default "__VITE_ASSET__W$AdxD_P__"